module.exports = {
	pageHeaderBorderRadius: '0',
	cardShadow: 'none',
	pageHeaderShadow: 'none',
	formLabelFontSize: '0.875rem',
	inputStaticFontSize: '1rem',
	inputStaticFontWeight: '400',
	cardFontWeight: '400',
};
